<template>
  <div>
    <ChildLogo></ChildLogo>
    <div class="bcakg">
      <div class="registerOK">
        <div>
          <img src="../../static/img/success.png" alt="" v-if="code==200" @click="loginRe">
          <img src="../../static/img/error.png" alt="" v-else>
        </div>
        <div>{{Tips}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
import {getFrontMenuMap} from '../api/register'
import {setToken} from '../utils/auth'
export default {
  components: {ChildLogo},
  data() {
    return {
      Tips : "",
      code : null,
      buttonName : "",
      user : {}
    };
  },
  mounted() {
    this.sid = this.$route.query.sid;
    var api = this.systemURL + "/actuator/before/activation";
    var params = {
      order: this.sid
    };
    this.axios.post(api, params).then(res => {
      this.code = res.data.code
      if (res.data.code == 200) {
        this.user = res.data.data;
        this.Tips = "注册成功,点击图标直接登陆";
      } else {
        this.Tips = "链接失效,请重新获取验证码";
      }
    });
  },
  methods:{
    loginRe(){
      var logiApi = this.systemURL + '/actuator/before/loginByReg?siteId=' + this.siteId
      var params = {
        userName: this.user.userName,
      }
      this.axios.post(logiApi, params).then(res => {
        if (res.data.code == 200) {
          this.$store.commit('setUser', res.data.user)
          setToken(res.data.token.access_token)
          this.codeStatus = false
          this.getPowerMenu()
          window.location.href = "/"
        }
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
        }
      })
    },
    getPowerMenu(){
      getFrontMenuMap(this.authURL).then(res => {
        this.$store.commit('setPwoerMenuIds', res.frontMenuMap)
        this.codeStatus = false
      })
    },
  }
};
</script>

<style scope>
.bcakg {
  background: url(../../static/img/successback.png) no-repeat center;
  background-repeat: no-repeat;
  height: calc(60vh);
  background-size: auto 100%;
}
.registerOK {
  height: calc(60vh);
  font-size: 22px;
  letter-spacing: 5px;
  font-weight: 500;
  text-align: center;
  padding: calc(20vh);
}
</style>



// WEBPACK FOOTER //
// src/views/RegistrationSuccess.vue